
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

import Icon from './Icon'

export default {
  name: 'OrderTimePicker',
  components: { Icon },
  props: {
    layout: {
      type: String,
      deafult: 'column',
    },
    config: {
      type: Object,
    }
  },
  data() {
    return {
      deliveryDays: [],
      times: [],
      day: null,
      time: null,
      disableAsap: false,
      defaultAsapUnMsg: {
        show: false,
        copy: 'Location is currently closed, you can schedule an order or come back later',
        nextAvailableTime: null,
        timeout: 5000,
      },
      readyTime: null,
      nextASAPTime: ""
    }
  },
  async mounted() {

    if (this.channel === 'catering') {
      this.setOrderMode('advance')
    }

    if (this.orderMode === 'advance' && !this.cart) {
      await this.createCart()
    }

    if (this.config?.locationCardInfo?.readyTimeText) {
      // This is for next available pickup time tile for Dig
      this.nextASAPTime = await this.getNextAvailableTime()
    }

    const advanceOrderDays = this.location && this.location.services.advancedays
      ? this.location.services.advancedays
      : 14

    let i = 0
    while (i < advanceOrderDays) {
      const day = moment().add(i, 'days')
      this.deliveryDays.push({
        dayOfWeek: day.format('ddd'),
        dayOfMonth: day.format('D'),
        fullDate: day.format('YYYYMMDD'),
      })
      i++
    }

    if (this.location && this.isOpen) {
      this.$utils.log('store is open')

      if (this.cart && this.cart.time) {
        if (this.cart.time.mode === 'asap') {
          this.setOrderMode('asap')
        } else {
          this.setOrderMode('advance')
          if (this.cart.time.wanted) {
            this.updateDayAndTime(this.cart.time.wanted)
          }
        }
      }
    } else {
      this.$utils.log('store not open')
      this.disableAsap = true
      this.setOrderMode('advance')

      if (this.cart && this.cart.time) {
        if (this.cart.time.mode === 'asap') {
          this.showAsapUnMsg()
        } else if (this.cart.time.wanted) {
          this.updateDayAndTime(this.cart.time.wanted)
        }
      } else {
        this.showAsapUnMsg()
      }
    }

    if (!this.cart && this.selectedDay !== null) {
      this.day = this.selectedDay
      await this.getTime(this.selectedDay)
      this.time = this.selectedTime ? this.selectedTime : null
    }
  },


  computed: {
    ...mapState(['location', 'cart', 'appInfo', 'channel']),
    ...mapState({
      orderMode: state => state.order.orderMode,
      selectedDay: state => state.order.selectedDay,
      selectedTime: state => state.order.selectedTime,
      asapUnavailable: state => state.order.asapUnavailable,
      handoffMode: state => state.order.handoffMode,
    }),

    getReadyTime() {
      const time = this.nextASAPTime;
      if (time) {
        return moment(this.nextASAPTime.next, 'YYYYMMDD HH:mm').format('h:mm A')
      } else {
        return false
      }
    },


    timeSelectorOptions() {
      return this.appInfo.order['time_selector_options']
    },
    asap() {
      return this.timeSelectorOptions ? this.timeSelectorOptions.asap : { text: 'ASAP' }
    },
    later() {
      return this.timeSelectorOptions ? this.timeSelectorOptions.later : { text: 'Later' }
    },
    advance() {
      return this.timeSelectorOptions ? this.timeSelectorOptions.advance : { date: 'Select Date', time: 'Select Time' }
    },
    showLocClosed() {
      if (this.asapUnavailable && this.asapUnavailable.disabled) {
        return false
      }

      return this.defaultAsapUnMsg.show
    },
    locClosedChip() {
      return this.asapUnavailable ? this.asapUnavailable.chip : true
    },
    locClosedTitle() {
      return this.asapUnavailable && this.asapUnavailable.title
        ? this.asapUnavailable.title
        : ''
    },
    locClosedCopy() {
      return this.asapUnavailable && this.asapUnavailable.copy
        ? this.asapUnavailable.copy
        : this.defaultAsapUnMsg.copy
    },
    locClosedTimeout() {
      return this.asapUnavailable && this.asapUnavailable.timeout
        ? this.asapUnavailable.timeout
        : this.defaultAsapUnMsg.timeout
    },

    isOpen() {
      const dayOfWeek = moment().format('YYYYMMDD')

      const hours = this.location.hours.find(h => h.date === dayOfWeek)

      if (hours !== undefined) {
        const now = this.nowTimeAtLocation
        const open = moment(hours.open, 'HH:mm')
        let close = moment(hours.close, 'HH:mm')

        // if close time is after midnight of the next day, add a day to close
        if (close <= open) {
          close = close.add(1, 'day')
        }

        const isOpen = now > open && now < close
        return isOpen
      }
    },
    nowTimeAtLocation() {
      let loc = this.location
      const localUtcOffset = moment().utcOffset() / 60
      const locationUtcOffset = loc.utcoffset || loc.utcOffset
      const absoluteLocalUtcOffset = Math.abs(localUtcOffset)
      const absoluteLocationUtcOffset = Math.abs(locationUtcOffset)
      const difference = Math.abs(localUtcOffset - locationUtcOffset)

      let now = moment()
      if (absoluteLocalUtcOffset < absoluteLocationUtcOffset) {
        // local time is ahead
        now = moment().subtract(difference, 'hours')
      } else if (absoluteLocalUtcOffset > absoluteLocationUtcOffset) {
        // local time is behind
        now = moment().add(difference, 'hours')
      }

      return now
    },
  },
  methods: {
    ...mapActions(['trackEvent', 'createCart']),
    ...mapActions({
      applyCartOrderAhead: 'checkout/applyCartOrderAhead',
      applyCartOrderAsap: 'checkout/applyCartOrderAsap',
      getNextAvailableTime: 'checkout/getNextAvailableTime',
      getCartAvailableTimes: 'checkout/getCartAvailableTimes',
    }),
    ...mapMutations({
      setOrderMode: 'order/setOrderMode',
      setSelectedDay: 'order/setSelectedDay',
      setSelectedTime: 'order/setSelectedTime',
    }),
    async showAsapUnMsg() {
      const nextAvailableTime = await this.getNextAvailableTime()
      if (nextAvailableTime && nextAvailableTime.next) {
        this.$utils.log('** Next Available Time **', nextAvailableTime.next)
        // const nextTimeUtc = moment(nextAvailableTime.next, 'YYYYMMDD HH:mm').utc().add(this.location?.utcOffset ?? 0, 'hours').format('YYYYMMDD HH:mm')
        const nextTimeUtc = moment(nextAvailableTime.next, 'YYYYMMDD HH:mm').format('YYYYMMDD HH:mm')
        this.defaultAsapUnMsg.nextAvailableTime = moment(nextTimeUtc, 'YYYYMMDD HH:mm').format('h:mm A')
        this.updateDayAndTime(nextTimeUtc, false)
        await this.applyCartOrderAhead(nextAvailableTime.next)
        this.trackEvent({
          name: 'set_order_time',
          data: nextAvailableTime.next,
          windowObject: window
        })
      }

      // shows up the ASAP Unavailable message
      this.defaultAsapUnMsg.show = true

      // fades the ASAP Unavailable message
      setTimeout(() => {
        this.defaultAsapUnMsg.show = false
      }, this.locClosedTimeout)
    },
    async updateDayAndTime(datestring, showAsapUnMsg = true) {
      if (!datestring) return null
      if (typeof datestring !== 'string') return null

      for (let d = 0; d < this.deliveryDays.length; d++) {
        if (datestring.includes(this.deliveryDays[d].fullDate)) {
          this.day = d
          this.setSelectedDay(this.day)
          await this.getTime(this.day)

          for (let t = 0; t < this.times.length; t++) {
            const cartTime = moment(datestring, 'YYYYMMDD HH:mm').format('h:mm A')
            if (cartTime === this.times[t]) {
              this.time = this.times[t]
              this.setSelectedTime(this.time)
              break
            }
          }
        }
      }

      if (showAsapUnMsg && (this.day === null || !this.time)) {
        // day and time not found, show asap message
        // this.showAsapUnMsg()
      }
    },
    getDay(day) {
      const newDay = moment(`${day.fullDate}`, 'YYYYMMDD').format('MMM D, YYYY')

      return newDay
    },
    async getTime(d) {
      if (d === null) {
        this.time = null
        this.times = []
        return
      }

      const times = []

      if (this.cart && this.cart.id) {
        // Dispatch action with the correct namespace due the param that is beeing sent through `OrderTimeChoose.vue` component.
        const timesResp = await this.$store.dispatch('checkout/getCartAvailableTimes', { deliveryDays: this.deliveryDays[d].fullDate });
        timesResp.map((t) => {
          const time = moment(t, 'YYYYMMDD HH:mm').format('h:mm A')
          times.push(time)
        })
      }

      this.time = null
      this.times = times
    },
    async setTime() {
      this.setSelectedDay(this.day)
      this.setSelectedTime(this.time)
      const day = this.deliveryDays[this.day]
      if (day && this.time) {
        const time = moment(`${day.fullDate} ${this.time}`, 'YYYYMMDD h:mm a').format('YYYYMMDD HH:mm')
        await this.applyCartOrderAhead(time)
        this.trackEvent({
          name: 'set_order_time',
          data: time,
          windowObject: window
        })
      }
    },
    async setAsap() {
      this.setOrderMode('asap')
      await this.applyCartOrderAsap()
    },
    async setOrderAhead() {
      if (!this.cart) {
        await this.createCart()
      }

      this.setOrderMode('advance')
    },

    formatTimeRange(startTime) {
      const start = moment(startTime, 'h:mm A');
      const end = start.clone().add(30, 'minutes');
      return `${start.format('h:mm A')} - ${end.format('h:mm A')}`;
    },
  }
}
